<template>
	<b-container>
		<b-col>
			<!-- calc form start -->
			<template v-if="calc">
				<b-row class="justify-content-between">
					<b-col class="order-2">
						<b-button @click="pdf" class="float-right" variant="primary" size="sm">Gerar PDF</b-button>
					</b-col>
					<b-col class="order-1">
						<b-form inline class @submit.prevent="calcularLucro">
							<div class="btn-group">
								<label for="inline-form-input-lucro" class="sr-only">Lucro</label>
								<money
									id="inline-form-input-lucro"
									placeholder="Lucro desejado"
									v-bind="lucroOption"
									v-model.lazy="lucro"
									class="money-div"
								></money>
								<b-button variant="success" size="sm" type="submit" @click="calcularLucro()">Calcular</b-button>
								<b-button variant size="sm" @click="zerarLucro">Limpar</b-button>
							</div>
						</b-form>
					</b-col>
				</b-row>
			</template>
			<!-- calc form end -->
			<hr>
			<b-row>
				<b-table responsive striped small :items="produtos" :fields="titulos">
					<template slot="precoAttribute" slot-scope="data">{{ data.value | currency(2) }}</template>
					<template slot="precoFinal" slot-scope="data">
						<div class="money-div">
							<money
								v-model="produtos[data.index].precoFinal"
								v-bind="money"
								class="form-input money-input"
							></money>
						</div>
					</template>
					<template slot="lucro" slot-scope="data">{{data.value | currency(2)}}</template>
				</b-table>
			</b-row>
		</b-col>
	</b-container>
</template>

<script>
import axios from "axios";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
export default {
	name: "calc-categoria",
	data() {
		return {
			caminho: "",
			toggle: true,
			lucro: 0,
			produtosProntos: [],
			produtos: [],
			titulos: [
				{ key: "referencia", label: "Ref." },
				{ key: "quantidade", label: "Quantidade" },
				{ key: "tamanho_sangria", label: "Tam. Arte" },
				{ key: "cobertura", label: "Cobertura" },
				{ key: "papel", label: "Material" },
                { key: "cor", label: "Cor" },
				{ key: "prazotexto", label: "Produção" },
				{ key: "precoAttribute", label: "Preço" },
				{ key: "precoFinal", label: "Preço Final" },
				{ key: "lucro", label: "Lucro" }
			],
			fields: [
				"referencia",
				"quantidade",
				"tamanho_sangria",
				"cobertura",
				"papel",
				"cor",
				"prazotexto",
				"precoFinal"
			],
			labels: [
				[
					"Ref",
					"Quantidade",
					"Tam. da Arte",
					"Cobertura",
					"Material",
					"Cor",
					"Produção",
					"Preço"
				]
			],
			money: {
				decimal: ",",
				thousands: ".",
				prefix: "R$ ",
				suffix: "",
				precision: 2,
				masked: false
			},
			lucroOption: {
				decimal: ",",
				thousands: ".",
				prefix: "",
				suffix: " %",
				precision: 0,
				masked: false
			}
		};
	},
	props: {
		lucroGlobal: 0,
		calc: Boolean,
		limpar: Boolean,
		categoria: Number
	},
	methods: {
		pdf: function() {
			this.calcularLucro();
			const doc = new jsPDF({
				orientation: "l",
				margin: { top: 40 },
				startY: 30
			});

			const rows = this.produtos.map(produto => {
				return this.fields
					.map(titulo => titulo)
					.map(coluna => {
						return this.tratamentoColuna(coluna, produto[coluna]);
					});
			});

			doc.text(this.caminho, 10, doc.lastAutoTable.finalY + 5 || 10);
			doc.autoTable({
				head: [...this.labels],
				body: rows
			});

			doc.save("table.pdf");
		},
		tratamentoColuna: function(coluna, dado) {
			if (
				coluna == "precoFinal" ||
				coluna == "precoAttribute" ||
				coluna == "lucro"
			) {
				return (
					"R$ " +
					parseFloat(dado)
						.toFixed(2)
						.toString()
				);
			} else if (coluna === "tamanho_sangria" && dado === "x") return "-";
			return dado;
		},
		calcularLucro: function() {
			this.produtos.forEach((produto, i) => {
				this.produtos[i].precoFinal =
					produto.precoAttribute * ((this.lucro + 100) / 100);
				this.produtos[i].lucro =
					this.produtos[i].precoFinal - this.produtos[i].precoAttribute;
			});
		},
		zerarLucro: function() {
			this.produtos.forEach((produto, i) => {
				this.produtos[i].precoFinal = produto.precoAttribute;
				this.produtos[i].lucro = 0;
			});
			this.lucro = 0;
		},
		fetchCategoriaPrecos: function() {
			axios
				.get(`/categorias/calc/${this.categoria}`)
				.then(response => {
					this.produtos = response.data.produtos;
					this.caminho = response.data.caminho;
					let qtds = [];
					for (let index = 0; index < this.produtos.length; index++) {
						this.produtos[index].precoFinal = this.produtos[
							index
						].precoAttribute;
						if (!this.produtos[index].qtd) continue;
						for (let j = 0; j < this.produtos[index].qtd.length; j++) {
							// js deep copy, ugly necessary hack
							// create a new produto for each {quantidade, valor}
							let produto = JSON.parse(JSON.stringify(this.produtos[index]));
							produto.quantidade = this.produtos[index].qtd[j].quantidade;
							produto.precoAttribute = this.produtos[index].qtd[j].valor;
							produto.precoFinal = produto.precoAttribute;
							qtds.push(produto);
						}
					}
					this.produtos.push(...qtds);
				})
				.catch(e => window.sendAlert(e.response));
		}
	},
	created: function() {
		this.fetchCategoriaPrecos();
	},
	watch: {
		lucroGlobal: function(val) {
			this.lucro = val;
			this.calcularLucro();
			this.$emit("pronto", {
				categoria: this.caminho,
				id: this.categoria,
				produtos: this.produtos
			});
		},
		limpar: function() {
			this.zerarLucro();
		},
		categoria: function(val) {
			this.fetchCategoriaPrecos();
		}
	}
};
</script>

<style scoped>
.money-input {
	max-width: inherit;
}
.money-div {
	max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/CalcCategoria.vue